module.exports = __webpack_public_path__ + "static/img/14.609bb01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/14.png
// module id = MDnJ
// module chunks = 0